module.exports = __webpack_public_path__ + "static/media/icon-finearts.aeea1980.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-finearts.svg
// module id = 1001
// module chunks = 0